import { ButtonHTMLAttributes } from 'react';
import Loaderbtn from "../../assets/svg/loading.gif";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    buttonText?: string;
    btnColor?: 'Approved' | 'Reject' | 'transparent' | 'disabled' | 'default' | 'endorsed' | 'border-primary' | 'white-btn';
    btnSize?: 'xl' | 'lg' | 'md' | 'sm' | 'xs' | 'auto' | 'default';
    btnIcon?: boolean;
    btnLabel?: boolean;
    IconSvg?: any;
    disabled?: boolean;
    className?: string;
    iconStyleClassName?: string;
    loading?: boolean;
    isIconLeft?: boolean;
};

export function Button({
    buttonText,
    btnColor = 'default',
    btnSize = 'default',
    btnIcon = false,
    btnLabel = false,
    IconSvg,
    disabled = false,
    onClick,
    className,
    iconStyleClassName,
    loading,
    isIconLeft = true,
    ...other
}: ButtonProps) {
    const getButtonColor = (color: 'Approved' | 'Reject' | 'transparent' | 'disabled' | 'default' | 'endorsed' | 'border-primary' | 'white-btn') => {
        switch (color) {
            case 'Approved':
                return "bg-transparent border-feildBorder border border-solid shadow-shadowAll  text-approvedDark font-bold hover:border-primary";
            case 'Reject':
                return "bg-transparent border-feildBorder border border-solid shadow-shadowAll text-rejectDark font-bold hover:border-primary";
            case 'transparent':
                return "bg-transparent ";
            case 'disabled':
                return "!bg-transparent border-feildBorder border border-solid !text-disabledDark !cursor-not-allowed";
            case 'endorsed':
                return "bg-transparent border-feildBorder border border-solid text-blackCol font-medium shadow-shadowAll hover:border-primary";
            case 'border-primary':
                return `border-primary text-primary border border-solid hover:bg-primary ${!disabled ? 'hover:text-white' : ''} font-bold`;
            case 'white-btn':
                return `border-feildBorder text-labelTextCol border border-solid hover:bg-primary ${!disabled ? 'hover:!text-whiteCol' : ''}  shadow-shadowAll`;
            default:
                return `bg-primary hover:bg-transparent ${!disabled ? 'hover:text-primary' : ''}  text-white border-primary border border-solid `;
        }
    };

    const getButtonSize = () => {
        switch (btnSize) {
            case 'xl':
                return "rounded-basicRadius px-5 py-3.5 w-24 text-sm !leading-[normal] font-aeonikBold";
            case 'lg':
                return "rounded-basicRadius  py-3 px-6 w-24 !leading-[normal] text-sm font-aeonikBold";
            case 'md':
                return "rounded-basicRadius  px-5 w-24 py-2.5 !leading-[normal] text-xs font-aeonikBold";
            case 'sm':
                return "rounded-basicRadius px-5 h-8 w-24 !leading-[normal]  text-sm font-aeonikBold";
            case 'xs':
                return "rounded-basicRadius px-5 h-7 w-24 !leading-[normal]  text-sm font-aeonikBold";
            case 'auto':
                return "rounded-basicRadius w-auto px-0 h-auto !leading-[normal]  text-sm font-aeonikBold";
            default:
                return "rounded-basicRadius  py-3 px-4  text-sm font-aeonikBold";
        }
    };

    return (
        <button
            onClick={!disabled ? onClick : undefined}
            className={`group ${getButtonColor(btnColor)} ${getButtonSize()} ${btnIcon && btnLabel ? "justify-center flex items-center [&_>_svg]:mr-1.5" : ""} ${className} ${disabled ? `${getButtonColor("disabled")}` : ""}`}
            disabled={disabled}
            {...other}
        >
            {isIconLeft && btnIcon && IconSvg && (
                <img src={IconSvg} alt="" className={`${iconStyleClassName}`} />
            )}

            {btnLabel && <div>{loading ? <div ><img src={Loaderbtn} alt="" className='mx-auto scale-[2] w-1/4' /></div> : buttonText}</div>}

            {!isIconLeft && btnIcon && IconSvg && (
                <img src={IconSvg} alt="" className={iconStyleClassName} />
            )}
        </button>

    );
};

export default Button;